import Entity from '@/resources/entities';

export default class Operacion extends Entity {
  static get modelName() {
    return 'Operacion'
  }
}